import { Box, Divider, Grid, Typography } from '@mui/material'
import React from 'react'
import Button from '@mui/material/Button';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import Avatar from '@mui/material/Avatar';
import NoResults from '../../components/reusableComponents/NoResults';
import { PulsateCardSkeleton } from '../../components/reusableComponents/SkeletonCard';

export default function Blogs({ Blogs, skeleton }) {
    return (
        <Box alignItems="stretch" sx={{ backgroundColor: "#FFFFFF", borderRadius: '20px', padding: '19px 18px', gap: '30px', display: 'flex', flexDirection: 'column' }}>
            <Box justifyContent={'space-between'} display={'flex'}>
                <Typography variant="h6" sx={{ color: '#1B2559', fontSize: '20px', fontWeight: 500 }}>Blogs</Typography>
                <a href='https://www.groovenexus.com/press-releases/' target='_blank' style={{ textDecoration: 'none' }}><Button size="small" sx={{ width: '78px', height: '32px', color: '#4318FF', backgroundColor: '#F4F7FE', textTransform: "capitalize", borderRadius: '35px', fontSize: '14px' }}>See all</Button></a>
            </Box>
            <Grid container spacing={3}>
                {skeleton ?
                    <PulsateCardSkeleton />
                    : Blogs.length ? Blogs.map((blog, i) => (
                        <Grid key={i} item xs={12} sm={6} md={4}>
                            <a href={blog.link} target='_blank' style={{ textDecoration: 'none' }}>
                                <Card sx={{ gap: '9px', boxShadow: 'none' }}>
                                    <CardMedia
                                        component="img"
                                        height="194"
                                        image={blog.image}
                                        alt="Blog"
                                    />
                                    <CardContent sx={{ padding: '9px 0 0 1px' }}>
                                        <Typography variant="body2" sx={{
                                            fontWeight: 700, color: '#1B2559', fontSize: '16px', letterSpacing: '-2%', textAlign: 'justify', display: '-webkit-box',  WebkitLineClamp: 2,
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                        }}>
                                            {blog.title}
                                        </Typography>
                                    </CardContent>
                                    <CardContent sx={{ padding: '9px 0 0 1px' }}>
                                        <Typography
                                            dangerouslySetInnerHTML={{
                                                __html: blog.subtitle,
                                            }}
                                            sx={{
                                                fontWeight: 400,
                                                color: '#A3AED0',
                                                fontSize: '14px',
                                                textAlign: 'justify',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 4,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                            }}
                                        />

                                    </CardContent>
                                    <CardContent sx={{ padding: '5px 0 0 1px', display: 'flex', gap: '12px', alignItems: 'center' , marginTop:'10px'}}>
                                        <Avatar
                                            src={blog.avatar}
                                            alt="User Avatar"
                                            sx={{ width: 32, height: 32 }}
                                        />
                                        <Typography sx={{ fontWeight: 400, color: '#828393', fontSize: '14px' }}>{blog?.author}</Typography>
                                        <Divider orientation="vertical" flexItem sx={{ height: 24, bgcolor: '#E0E0E0', width: '2px', alignSelf: 'center', minHeight: 24 }} />
                                        <Typography sx={{ fontWeight: 400, color: '#686E6D', fontSize: '14px' }}>
                                            {/* {blog.date} */}
                                            {new Date(blog.date).toLocaleDateString('en-US', {
                                                month: 'short',
                                                day: 'numeric',
                                                year: 'numeric'
                                            })}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </a>
                        </Grid>)) : <NoResults />}
            </Grid>

        </Box>
    )
}
